import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { DashboardComponent } from "./dashboard/dashboard.component";
import { ComprarPaquetesComponent } from "./paquetes/comprar-paquetes/comprar-paquetes.component";
import { CitasListComponent } from "./citas/citas-list/citas-list.component";
import { CitasListNewComponent } from "./citas/citas-list-new/citas-list-new.component";
import { ConsentimientoComponent } from "./consentimiento/consentimiento.component";
import { PerfilComponent } from "./perfil/perfil.component";
import { BuscadorWizardComponent } from "./buscador-wizard/buscador-wizard.component";
import { ProximasCitasComponent } from './citas/proximas-citas/proximas-citas.component';
import { HistorialCitasComponent } from "./historial-citas/historial-citas.component";
import { MisPaquetesComponent } from './paquetes/mis-paquetes/mis-paquetes.component';
import { ListadoPaquetesComponent } from './paquetes/listado-paquetes/listado-paquetes.component';
import { EmocionesComponent } from "./emociones/emociones.component";

const routes: Routes = [
  {
    path: "",
    component: DashboardComponent,
  },
  {
    path: "paquetes-comprar/:idPaquete",
    component: ComprarPaquetesComponent,
  },
  // NUEVA CITA
  {
    path: "citas-list",
    component: CitasListComponent,
  },
  {
    path: "citas-new",
    component: CitasListNewComponent,
  },
  {
    path: "consentimiento",
    component: ConsentimientoComponent,
  },
  {
    path: "perfil",
    component: PerfilComponent,
  },
  {
    path: "buscador-wizard",
    component: BuscadorWizardComponent,
  },
  // MIS CITAS
  {
    path: "mis-citas",
    component: ProximasCitasComponent,
  },
  {
    path: 'mis-paquetes',
    component: MisPaquetesComponent,
  },
  {
    path: 'listado-paquetes',
    component: ListadoPaquetesComponent,
  },
  {
    path: 'historial-citas',
    component: HistorialCitasComponent,
  },
  {
    path: 'diario-emociones',
    component: EmocionesComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
